import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProfileService } from '../profile.service';
import { AuthService } from '../../auth/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { LoggerService } from '../../logger/logger.service';
import {UpdateContact} from '../contact-info/contact-info.component';

const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$|^\d{10}$/;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
  selector: 'app-contact-verify',
  templateUrl: './contact-verify.component.html',
  styleUrls: ['./contact-verify.component.css']
})
export class ContactVerifyComponent implements OnInit {
  private token: string;
  private person: any;
  private service_address: Object;
  private user_id: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public mobile_no: string;

  public hasEmail: boolean;
  public dropDisable: boolean;
  public hasMobile: boolean;
  public isEmailError: boolean = false;
  public isMobileError: boolean = false;
  public isContactMethodChanged: boolean;
  public isEmailVerified: boolean;
  public isMobileVerified: boolean;
  private isEmailAddUpdate: boolean;
  private isMobileAddUpdate: boolean;
  public is_loader: boolean;
  public is_acc_setting: boolean = false;
  public is_contact_method_changed: boolean = false;
  public dropDisabled: boolean = false;
  public emailError = "";
  public mobileError = "";
  public saveText = 'Save';

  public preferred_contact_method;

  methods = [];

  mobilePhoneFormControl = new FormControl('', [
    Validators.pattern(MOBILE_REGEX)
  ]);
  emailFormControl = new FormControl('', [
    Validators.pattern(EMAIL_REGEX)
  ]);

  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(private sharedService: SharedService, private localStorageService: LocalStorageService, private authService: AuthService, private activatedRoute: ActivatedRoute, private profileService: ProfileService, private router: Router, private dialog: MatDialog, private logger: LoggerService) {
    this.sharedService.setHeaderTitle('default_page');
    this.token = this.localStorageService.get('token')
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.activatedRoute.params.subscribe((params: Params) => {
      let acc_setting = params['account_setting'];
      this.is_acc_setting = acc_setting != undefined && acc_setting.trim() == "AccountSetting";
    });
    if (this.token != undefined && this.token.trim() != '') {
      this.sharedService.verifyToken({ 'token': this.token })
        .then((res) => {
          this.is_loader = false;
          if (res.status === 'success') { //&& res.isTerminated === false
            this.person = res.results[0]['personal'][0];
            this.service_address = res.results[0]['service'][0];
            //this.preferred_contact_method = this.person['preferedContactMethod'];
            this.user_id = this.person['id'];
            this.firstName = this.person['firstName'];
            this.lastName = this.person['lastName'];
            this.email = this.person['email'];
            this.mobile_no = this.person['mobilePhoneNumber'];

            const that = this.sharedService;
            setTimeout(function () {
              that.setHeaderSuccessMessage('contact_info', false, '');
              that.setHeaderErrorMessage('contact_info', false, 'notification error', '');
              that.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
              // that.setHeaderTitleDynamicVal('account_setting', 'Account Settings', 'Account Number ' + person['account_number']);
            }, 10);
            this.sharedService.setLoader('contact_info', false);
            this.sharedService.setHeaderUserLoggedIn('contact_info', true, this.person);

            if (this.email != "") {
              if (this.person['isEmailVerify'] == '1') {
                this.isEmailAddUpdate = true;
                this.isEmailVerified = true;
              } else {
                this.isEmailAddUpdate = false;
                this.isEmailVerified = false;
              }
            }

            if (this.mobile_no != "") {
              if (this.person['isOtpVerify'] == '1') {
                this.isMobileAddUpdate = true;
                this.isMobileVerified = true;
              } else {
                this.isMobileAddUpdate = false;
                this.isMobileVerified = false;
              }
            }

            if (this.email == "" || this.mobile_no == "") {
              if (this.email != "") {
                //this.methods = null;
                this.isContactMethodChanged = false;
                this.methods = [{ value: 'Email', viewValue: 'Email' }];
                this.preferred_contact_method = "Email";
                this.dropDisabled = true;
              }

              if (this.mobile_no != "") {
                this.isContactMethodChanged = false;
                this.methods = [{ value: 'Mobile', viewValue: 'Mobile' }];
                this.preferred_contact_method = "Mobile";
                this.dropDisabled = true;
              }
            }
            else if (this.email != "" && this.mobile_no != "") {
              //this.isContactMethodChanged=true;
              this.methods = [
                { value: 'Mobile', viewValue: 'Mobile' },
                { value: 'Email', viewValue: 'Email' },
                { value: 'Both', viewValue: 'Both' }
              ];
              this.preferred_contact_method = this.person['preferedContactMethod'];
              //this.dropDisable=false;
            }

            this.isContactMethodChanged = false;

            this.hasEmail = this.email != undefined && this.email.trim() != '';
            this.hasMobile = this.mobile_no != undefined && this.mobile_no.trim() != '';

            this.sharedService.setHeaderUserLoggedIn('contact_info', true, this.person);
            this.sharedService.listenLanguageCookieChange(({oldValue, newValue}) => {
              this.saveText = this.sharedService.getSaveTranslation();
            }, 1000);
          } else {
            this.localStorageService.remove('token');
            this.router.navigate(['./enroll']);
          }
        });
    } else {
      this.router.navigate(['./enroll']);
    }

  }

  unmaskData(data: string) {
    if (data != null && data.trim()!="") {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return "";
    }
  }

  // validation of email
  emailValidate(email: any) {
    this.isEmailError = false;
    if (this.email != null && this.email != undefined && this.email.trim() != "") {

      if (this.person['email'].trim() == this.email.trim()) {
        if (this.person['isEmailVerify'] == '1') {
          this.isEmailAddUpdate = true;
          this.isEmailVerified = true;
        } else {
          this.isEmailAddUpdate = false;
          this.isEmailVerified = false;
        }
      } else {
        this.isEmailVerified = false;
        this.isEmailAddUpdate = true;
      }

      // this.isEmailVerified = (this.person['email'].trim() == this.email.trim());
      // this.isEmailAddUpdate = !this.isEmailVerified;
    } else {
      this.isEmailVerified = false;//(this.email == undefined || this.email.trim() == "");
      this.isEmailAddUpdate = !this.isEmailVerified && this.person['isEmailVerify'];
    }

    if (this.email != undefined && this.email.trim() != "" && this.email.match(EMAIL_REGEX)) {
      this.hasEmail = true;
    } else {
      this.hasEmail = false;
    }
  }

  // validation of mobile
  mobileValidate(mobile: any) {
    this.isMobileError = false;
    if (this.mobile_no != undefined && this.mobile_no.trim() != "") {
      if (this.person['mobilePhoneNumber'].trim() == this.unmaskData(this.mobile_no.trim())) {
        // this.isMobileVerified = this.person['isOtpVerify'];
        if (this.person['isOtpVerify'] == '1') {
          this.isMobileAddUpdate = true;
          this.isMobileVerified = true;
        } else {
          this.isMobileAddUpdate = false;
          this.isMobileVerified = false;
        }
      } else {
        this.isMobileVerified = false;
        this.isMobileAddUpdate = true;
      }
      // this.isMobileVerified = (this.person['mobilePhoneNumber'].trim() == this.unmaskData(this.mobile_no.trim()));
      // this.isMobileAddUpdate = !this.isMobileVerified;
    } else {
      this.isMobileVerified = false;
      this.isMobileAddUpdate = !this.isMobileVerified && this.person['isOtpVerify'];
    }

    if (this.mobile_no != undefined && this.mobile_no.trim() != "" && this.mobile_no.match(MOBILE_REGEX)) {
      this.hasMobile = true;
    } else {
      this.hasMobile = false;
    }
  }

  verifyMobile() {
    if (this.isMobileAddUpdate) {
      this.addUpdateMobile();
    } else {
      this.resendOTP('mobile');
    }
  }

  addUpdateMobile() {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('contact_info', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name + '.updateMobile';
    this.profileService.updateMobile({ 'token': this.localStorageService.get('token'), 'mobile': this.unmaskData(this.mobile_no) })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked], mobile: "+this.unmaskData(this.mobile_no),
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.is_loader = false;
        this.sharedService.setLoader('contact_info', false);
        this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
        if (res.status === 'success') {
          this.dialog.open(UpdateContact, {
            data: {
              message: res.message,
              raw_id: this.user_id,
              is_acc_setting: this.is_acc_setting,
              for_what: "mobile",
              is_verify_request: true
            }
          });
        } else {
          this.isMobileError = true;
          this.mobileError = res.message;
          // this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', res.result.message);
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], mobile: "+this.unmaskData(this.mobile_no),
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], mobile: "+this.unmaskData(this.mobile_no),
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  verifyEmail() {
    if (this.isEmailAddUpdate) {
      this.addUpdateEmail();
    } else {
      this.resendOTP('email');
    }
  }

  addUpdateEmail() {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('contact_info', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name + '.updateEmail';
    this.profileService.updateEmail({ 'token': this.localStorageService.get('token'), 'email': this.email })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked], email : "+ this.email,
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.is_loader = false;
        this.sharedService.setLoader('contact_info', false);
        this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
        if (res.status === 'success') {
          this.dialog.open(UpdateContact, {
            data: {
              message: res.message,
              raw_id: this.user_id,
              is_acc_setting: this.is_acc_setting,
              for_what: "email",
              is_verify_request: true
            }
          });
        } else {
          this.isEmailError = true;
          this.emailError = res.message;
          // this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', res.message);
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], email : "+ this.email,
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: "token : [masked], email : "+ this.email,
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  resendOTP(for_what) {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
    this.sharedService.setHeaderErrorMessage('contact_info', false, 'notification error', '');
    this.sharedService.setHeaderSuccessMessage('contact_info', false, 'Your OTP has been successfully sent.');
    let methodName = this.constructor.name + '.resendOTP';
    this.authService.resendOTP({ 'token': this.token, 'sFor': for_what, 'accSetting': this.is_acc_setting })
      .then(res => {
        let logObj = {
          method: methodName,
          request: "token : [masked]",
          response: res
        };
        this.logger.logInfo(JSON.stringify(logObj));
        this.is_loader = false;
        this.sharedService.setLoader('contact_info', false);
        this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
        if (res.status === 'success') {
          if (for_what.trim() == 'email') {
            this.dialog.open(UpdateContact, {
              data: {
                message: "We have sent an OTP via email to your email address.",
                raw_id: this.user_id,
                is_acc_setting: this.is_acc_setting,
                for_what: for_what,
                is_verify_request: true
              }
            });
          } else {
            this.dialog.open(UpdateContact, {
              data: {
                message: "The OTP has been sent to the mobile number.",
                raw_id: this.user_id,
                is_acc_setting: this.is_acc_setting,
                for_what: for_what,
                is_verify_request: true
              }
            });
          }
        } else {
          if (for_what.trim() == 'email') {
            this.isEmailError = true;
            this.emailError = res.message;
          } else {
            this.isMobileError = true;
            this.mobileError = res.message;
          }
          // this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', res.result.message);
        }
      }, (error) => {
        let logObj = {
          method: methodName,
          request: "token : [masked]",
          exception: error
        };
        this.logger.logError(JSON.stringify(logObj));
      }).catch((ex) => {
        let logObj = {
          method: methodName,
          request: "token : [masked]",
          exception: ex
        };
        this.logger.logError(JSON.stringify(logObj));
      });
  }

  ngOnInit() {
  }

  contactMethodValidate(contactMethod) {
    this.isContactMethodChanged = this.preferred_contact_method.trim() != this.person['preferedContactMethod'].trim();
  }

  contactMethodSave() {
    this.is_loader = true;
    this.sharedService.setLoader('contact_info', true);
    this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
    let notification_channel_setting = {
      'token': this.localStorageService.get('token'),
      'preferredContactMethod': this.preferred_contact_method
    };
    let methodName = this.constructor.name + '.updateNotificationChannel';
    this.profileService.updateNotificationChannel(notification_channel_setting).then(res => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        response: res
      };
      this.logger.logInfo(JSON.stringify(logObj));
      window.scrollTo(0, 0);
      this.is_loader = false;
      this.sharedService.setLoader('contact_info', false);
      this.sharedService.setHeaderTitleDynamicVal('contact_info', 'Verify Contact Information', '');
      if (res.status === 'success') {
        this.sharedService.setHeaderSuccessMessage('contact_info', true, "Preferred Contact Method Updated Successfully.");
        const this_obj = this;
        this.person['preferedContactMethod'] = this.preferred_contact_method;
        this.isContactMethodChanged = false;
        setTimeout(function () {
          this_obj.sharedService.setHeaderSuccessMessage('contact_info', false, '');
        }, 5000);
      } else {
        if (res.type === 'timeup') {
          this.router.navigate(['./Profile/AccountSetting/SignIn']);
        } else {
          this.sharedService.setHeaderErrorMessage('contact_info', true, 'notification error', res.message);
        }
      }
    }, (error) => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        exception: error
      };
      this.logger.logError(JSON.stringify(logObj));
    }).catch((ex) => {
      let logObj = {
        method: methodName,
        request: notification_channel_setting,
        exception: ex
      };
      this.logger.logError(JSON.stringify(logObj));
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/contact-verify/contact-verify.component.ts